export const globals = {
    maxSizeWidthScreen: 1280,
    maxSizeHeightScreen: 1280,
    minSizeWidthScreen: 270,
    minSizeHeightScreen: 480,
    sizeWidthScreen: 540,
    sizeHeightScreen: 960,
    debugMode: false,
    gameMode: '',
    scenes: {
        levelSelector: {
            cameraScrollY: null
        }
    }
};